export default __webpack_public_path__ + "media/images/cls-logo.png";